// extracted by mini-css-extract-plugin
export default {"container":"style_container__6d9FM","paper":"style_paper__MD+Rm","separator":"style_separator__Erp1D"};